import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import RootRoutes from './routes-content';

const App = ({ store }: { store: any }) => (
  <Provider store={store}>
    <Router>
      <RootRoutes />
    </Router>
  </Provider>
);

export default App;
